module.exports = __webpack_public_path__ + "img/dxctj-4000.b879d27f.jpg";